export const paymentReferenceMaxLengths: {
  [key: string]: {
    fullName: string;
    swift: {
      maxLength: number | null;
    };
    local: {
      maxLength: number | null;
    };
  };
} = {
  AUD: {
    fullName: 'Australian Dollar (AUD)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  BHD: {
    fullName: 'Bahrain Dinar (BHD)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  CAD: {
    fullName: 'Canadian Dollar (CAD)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: 100,
    },
  },
  CNY: {
    fullName: 'Chinese Yuan (CNY)',
    swift: {
      maxLength: 135,
    },
    local: {
      maxLength: 140,
    },
  },
  CZK: {
    fullName: 'Czech Koruna (CZK)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  DKK: {
    fullName: 'Danish Krone (DKK)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  EUR: {
    fullName: 'Euro (EUR)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: 140,
    },
  },
  HKD: {
    fullName: 'Hong Kong Dollar (HKD)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: 200,
    },
  },
  HUF: {
    fullName: 'Hungarian Forint (HUF)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: 140,
    },
  },
  IDR: {
    fullName: 'Indonesian Rupiah (IDR)',
    swift: {
      maxLength: null,
    },
    local: {
      maxLength: null,
    },
  },
  ILS: {
    fullName: 'Israeli Shekel (ILS)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  KES: {
    fullName: 'Kenyan Shilling (KES)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  KWD: {
    fullName: 'Kuwaiti Dinar (KWD)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  MYR: {
    fullName: 'Malaysian Ringgit (MYR)',
    swift: {
      maxLength: null,
    },
    local: {
      maxLength: null,
    },
  },
  MXN: {
    fullName: 'Mexican Peso (MXN)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  NZD: {
    fullName: 'New Zealand Dollar (NZD)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  NOK: {
    fullName: 'Norwegian Krone (NOK)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  OMR: {
    fullName: 'Omani Rial (OMR)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  PHP: {
    fullName: 'Philippine Peso (PHP)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  PLN: {
    fullName: 'Polish Zloty (PLN)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  QAR: {
    fullName: 'Qatari Rial (QAR)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: 140,
    },
  },
  RON: {
    fullName: 'Romanian Leu (RON)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  SAR: {
    fullName: 'Saudi Riyal (SAR)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: 200,
    },
  },
  SGD: {
    fullName: 'Singapore Dollar (SGD)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  ZAR: {
    fullName: 'South African Rand (ZAR)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  SEK: {
    fullName: 'Swedish Krona (SEK)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  CHF: {
    fullName: 'Swiss Franc (CHF)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  THB: {
    fullName: 'Thai Baht (THB)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  TRY: {
    fullName: 'Turkish Lira (TRY)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  UGX: {
    fullName: 'Ugandan Shilling (UGX)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  GBP: {
    fullName: 'UK Sterling (GBP)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: 18,
    },
  },
  AED: {
    fullName: 'United Arab Emirates Dirham (AED)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: null,
    },
  },
  USD: {
    fullName: 'US Dollar (USD)',
    swift: {
      maxLength: 132,
    },
    local: {
      maxLength: 10,
    },
  },
};
